import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { Form, PrimaryButton, FieldTextInput, IconSearch } from '../../components';

import css from './HeroSearch.module.css';

const HeroSearchFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        rootClassName,
        className,
        formId,
        handleSubmit,
        inProgress,
        intl,
        invalid,
        name,
        values
      } = fieldRenderProps;

      const classes = classNames(rootClassName || css.rootForm, className);
      const submitInProgress = inProgress;
      const submitDisabled = invalid || submitInProgress;

      const educatorsPlaceHolder = intl.formatMessage({
        id: 'HeroSearch.educatorsPlaceHolder',
      });
      const workshopsPlaceHolder = intl.formatMessage({
        id: 'HeroSearch.workshopsPlaceHolder',
      });

      const placeholder = name === 'searchEducators' ? educatorsPlaceHolder : workshopsPlaceHolder;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <div className={css.fieldHolder}>
            <IconSearch />
            <FieldTextInput
              type="text"
              id="keywords"
              name="keywords"
              className={css.field}
              placeholder={placeholder}
            />
          </div>
          <FieldTextInput
            id="listingType"
            name="listingType"
            type="hidden"
          />
          <PrimaryButton
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            className={css.button}
          >
            <FormattedMessage id="HeroSearch.search" />
          </PrimaryButton>
        </Form>
      );
    }}
  />
);

/**
 * A component that renders the login form.
 *
 * @component
 * @param {Object} props
 * @param {string} props.rootClassName - The root class name that overrides the default class css.root
 * @param {string} props.className - The class that extends the root class
 * @returns {JSX.Element}
 */
const HeroSearchForm = props => {
  const intl = useIntl();
  return <HeroSearchFormComponent {...props} intl={intl} />;
};

export default HeroSearchForm;
